export var shortAddress = function (address) {
    if (!address)
        return;
    var first = address.substring(0, 4);
    var last = address.substring(address.length - 4);
    return "".concat(first, ".....").concat(last);
};
